module.exports = __webpack_public_path__ + "static/media/christian.b23f7205.jpg";